import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '@figure/frontlib-gui';
import { useRedirect } from 'shared/hooks';
import { PageHeader } from 'shared/components/Typography';
import TimeoutImage from 'shared/assets/images/timeout.svg';

const ImageWrapper = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  margin-top: 1.6rem;
`;

const ReviewAppBase = ({ children }) => {
  const { t } = useTranslation();
  const { redirectToDashboard } = useRedirect();
  const companySingleName = t('companySingleName');
  const handleDashboardClick = () => redirectToDashboard();

  return (
    <>
      <PageHeader>Thank you for submitting an application for a {companySingleName} Personal Loan</PageHeader>
      {children}

      <ImageWrapper>
        <img src={TimeoutImage} alt="" />
      </ImageWrapper>
      <Button primary large center onClick={handleDashboardClick}>
        Go to dashboard
      </Button>
    </>
  );
};

ReviewAppBase.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ReviewAppBase;
